import {Injectable} from '@angular/core';
import {JsonhelperInterface} from "./jsonhelper.interface";

/**
 * class > SirenHelper
 *
 *
 * @desc Helper-Klasse um durch ein nach dem Siren-Format aufgebautes json-Objekt zu navigieren
 * (Zum Aufbau von Siren vgl. https://github.com/kevinswiber/siren)
 */
@Injectable()
export class SirenHelper implements JsonhelperInterface{


    /**
     * Function > getObjectByProperty
     *
     * @desc Gibt aus einem Array von JSON-Objekten dasjenige zurueck, das fuer uebergebenen property uebergebene Wert hat
     * @param {string} STR_property_name
     * @param {string} STR_property_value
     * @param ARR_siren_json
     * @return OBJ_entity
     * */
    public getObjectByProperty(STR_property_name: string, STR_property_value: string, ARR_siren_json) {
        // JSON durchgehen und zu der jeweiligen Route die Konfiguration holen
        for (let OBJ_entity of ARR_siren_json) {
            if (this.getProperty(STR_property_name, OBJ_entity) == STR_property_value) {
                return OBJ_entity;
            } // end if

        } // end for


    } // end function getObjectByProperty


    /**
     * Function > getEmbeddedRessources
     *
     * @desc gibt die Entities der uebergebenen Entity zurueck
     * @param OBJ_siren_json
     * @return {array}
     */
    public getEmbeddedRessources(OBJ_siren_json) {
        return OBJ_siren_json.entities;
    } // end function getEmbeddedRessources


    /**
     * Function > hasProperty
     * @desc Uerbeprueft ob ein property mit dem uebergebenem Namen im uebergebenem Siren-Json vorhanden ist
     * @param {string} STR_name
     * @param OBJ_siren_json
     * @return {boolean}
     */
    public hasProperty(STR_name: string, OBJ_siren_json)
    {
        return this.getProperties(OBJ_siren_json).hasOwnProperty(STR_name);

    } // end function hasProperty


    /**
     * Function > getProperty
     *
     * @desc Gibt Inhalt des properties mit dem uebergebenen Namen zurueck falls vorhanden, ansonsten undefined
     * @param {string} STR_name
     * @param OBJ_siren_json
     * @return
     */
    public getProperty(STR_name: string, OBJ_siren_json) {

        if(this.getProperties(OBJ_siren_json).hasOwnProperty(STR_name))
        {
            return this.getProperties(OBJ_siren_json)[STR_name];
        }
        else
        {
            return null;

        } // end if

    } // end function getProperty


    /**
     * Function > updateProperty
     *
     * @desc Setzt Inhalt des properties mit dem uebergebenen Namen auf uebergebenen Wert
     * @param {string} STR_name
     * @param OBJ_value
     * @param OBJ_siren_json
     */
    public updateProperty(STR_name: string, OBJ_value,  OBJ_siren_json) {

        if(this.hasProperty(STR_name, OBJ_siren_json))
        {
            OBJ_siren_json.properties[STR_name] = OBJ_value;
            return true;
        }
        else
        {
            return false;
        }

    } // end function updateProperty


    /**
     * Function > getProperties
     *
     * @desc Gibt die properties der uebergebenen Entity zurueck
     * @param OBJ_siren_json
     * @return {array}
     */
    public getProperties(OBJ_siren_json) {
        return OBJ_siren_json.properties;

    } // end function getProperties


    /**
     * Function > getLinks
     *
     * @desc Gibt die Links der uebergebenen Entity zurueck
     * @param OBJ_siren_json
     * @return {array}
     */
    public getLinks(OBJ_siren_json) {
        return OBJ_siren_json.links;
    } // end function getLinks


    /**
     * Function > getLink
     *
     * @desc gibt den Link mit dem uebergebenen rel-Attribute zurueck
     * @param {string} STR_rel
     * @param OBJ_siren_json
     * @return {string}
     */
    public getLinkByRel(STR_rel: string, OBJ_siren_json)
    {
        for(let OBJ_link of this.getLinks(OBJ_siren_json))
        {
            // Hole den link der zum REST-Endpoint mit den Daten verweist
            if (OBJ_link.rel[0] == STR_rel)
            {
                return OBJ_link.href;
            } // end if

        } // end for

        return null;

    } // end function getLink


    /**
     * Function > getLinkToSelf
     * @desc Gibt Link zum REST-Endpoint der geladenen Daten zurueck
     * @param OBJ_siren_json
     * @return {string} Link zum REST-Endpoint der aktuellen Daten
     */
    getLinkToSelf(OBJ_siren_json)
    {
        return this.getLinkByRel("self", OBJ_siren_json);
    } // end function getLinkToSelf



} // end class SirenHelper
